/**
 * A decision on a change: somebody accepted it or rejected it, reading the
 * report against one of its versions.
 *
 * Written by the server with who took it and when. It speaks for the section as
 * it was then: once the section is changed again the decision is `stale`, and
 * the change is to be read afresh.
 */

export type Decision = 'accepted' | 'rejected'

export interface Review {
  readonly sectionId: string
  readonly decision: Decision
  /** The section's title when it was decided: what to call it once it is gone. */
  readonly title: string
  readonly author: string
  readonly decidedAt: string
  /** The section was changed after this was decided. */
  readonly stale: boolean
}

/** The stored shape of a decision, as the API sends it. */
export interface StoredReview {
  section_id: string
  decision: string
  title: string
  author: string
  created_at: string
  stale: boolean
}

export function readReview(stored: StoredReview): Review {
  return {
    sectionId: stored.section_id,
    decision: stored.decision === 'rejected' ? 'rejected' : 'accepted',
    title: stored.title,
    author: stored.author,
    decidedAt: stored.created_at,
    stale: stored.stale,
  }
}
